// Routen der Oberfläche. Seiten liegen in src/pages (feste Dateinamen, siehe crm/ZUSTAENDIGKEIT.md).
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { AppLayout } from "./components/AppLayout";
import { MeldungenProvider } from "./components/Meldungen";
import { setzeErgebnisFormular } from "./components/TelefonieTeile";
import { NachAnrufFormular } from "./components/lead/NachAnrufFormular";
import Aktivitaeten from "./pages/Aktivitaeten";
import Berichte from "./pages/Berichte";
import Dubletten from "./pages/Dubletten";
import Gespraeche from "./pages/Gespraeche";
import Einstellungen from "./pages/Einstellungen";
import Inbox from "./pages/Inbox";
import Kontakte from "./pages/Kontakte";
import Lead from "./pages/Lead";
import Leads from "./pages/Leads";
import Login from "./pages/Login";
import Opportunities from "./pages/Opportunities";
import SmartView from "./pages/SmartView";
import SmartViews from "./pages/SmartViews";
import Workflows from "./pages/Workflows";
import { TelefonieProvider } from "./telefonie";

// Nach dem Anruf trägt das Telefon-Feld das Ergebnis mit dem Custom-Activity-Formular der Oberfläche ein.
setzeErgebnisFormular?.(NachAnrufFormular);

export default function App() {
  return (
    <AuthProvider>
      <MeldungenProvider>
        <TelefonieProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<AppLayout />}>
              <Route index element={<Navigate to="/inbox" replace />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/smart-views" element={<Navigate to="/smart-views/alle" replace />} />
              <Route path="/smart-views/alle" element={<SmartViews art="alle" />} />
              <Route path="/smart-views/eigene" element={<SmartViews art="eigene" />} />
              <Route path="/smart-views/geteilt" element={<SmartViews art="geteilt" />} />
              <Route path="/smart-views/andere" element={<SmartViews art="andere" />} />
              <Route path="/smart-views/:viewId" element={<SmartView />} />
              <Route path="/lead/:leadId" element={<Lead />} />
              {/* Einstellungen: zweite Navigationsspalte, Unterseiten (pages/einstellungen/seiten.ts) */}
              <Route path="/einstellungen/*" element={<Einstellungen />} />
              {/* Workflows (Agent 4C): Liste, Editor und Läufe legt die Seite mit eigenen Unterrouten an */}
              <Route path="/workflows/*" element={<Workflows />} />
              {/* Runde 5: Seiten der Agenten 5C (Kontakte, Aktivitäten) und 5D (Opportunities), mit eigenen Unterrouten */}
              <Route path="/kontakte" element={<Kontakte />} />
              <Route path="/aktivitaeten/*" element={<Aktivitaeten />} />
              <Route path="/opportunities/*" element={<Opportunities />} />
              {/* Runde 7: Seiten der Agenten 7A (Berichte), 7D (Gespräche) und 7C (Dubletten), mit eigenen Unterrouten */}
              <Route path="/reports/*" element={<Berichte />} />
              <Route path="/gespraeche/*" element={<Gespraeche />} />
              <Route path="/dubletten" element={<Dubletten />} />
              <Route path="*" element={<Navigate to="/inbox" replace />} />
            </Route>
          </Routes>
        </TelefonieProvider>
      </MeldungenProvider>
    </AuthProvider>
  );
}
